import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRecentEventListQueryVariables = Types.Exact<{
  input: Types.GetRecentEventListInput;
}>;

export type GetRecentEventListQuery = {
  __typename?: 'Query';
  getRecentEventList: {
    __typename?: 'GetRecentEventListResponse';
    items: Array<{
      __typename?: 'GetRecentEventListEvent';
      category: string;
      classification: string;
      complianceRate?: number | null;
      createdAt: string;
      expectedParticipantsNumber?: number | null;
      incidentNumber?: number | null;
      name: string;
      riskManagementScore?: number | null;
      startDate: string;
      endDate: string;
      updatedAt: string;
      uuid: string;
      status: {
        __typename?: 'GetRecentEventListStatus';
        name: string;
        uuid: string;
      };
    }>;
    pagination?: {
      __typename?: 'PaginationResponse';
      pageNumber: number;
      pageSize: number;
      total: number;
      totalPage: number;
    } | null;
  };
};

export const GetRecentEventListDocument = gql`
  query GetRecentEventList($input: GetRecentEventListInput!) {
    getRecentEventList(input: $input) {
      items {
        category
        classification
        complianceRate
        createdAt
        expectedParticipantsNumber
        incidentNumber
        name
        riskManagementScore
        startDate
        endDate
        status {
          name
          uuid
        }
        updatedAt
        uuid
      }
      pagination {
        pageNumber
        pageSize
        total
        totalPage
      }
    }
  }
`;
export function useGetRecentEventListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRecentEventListQuery,
    GetRecentEventListQueryVariables
  > &
    (
      | { variables: GetRecentEventListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRecentEventListQuery,
    GetRecentEventListQueryVariables
  >(GetRecentEventListDocument, options);
}
export function useGetRecentEventListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRecentEventListQuery,
    GetRecentEventListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRecentEventListQuery,
    GetRecentEventListQueryVariables
  >(GetRecentEventListDocument, options);
}
export function useGetRecentEventListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRecentEventListQuery,
        GetRecentEventListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRecentEventListQuery,
    GetRecentEventListQueryVariables
  >(GetRecentEventListDocument, options);
}
export type GetRecentEventListQueryHookResult = ReturnType<
  typeof useGetRecentEventListQuery
>;
export type GetRecentEventListLazyQueryHookResult = ReturnType<
  typeof useGetRecentEventListLazyQuery
>;
export type GetRecentEventListSuspenseQueryHookResult = ReturnType<
  typeof useGetRecentEventListSuspenseQuery
>;
export type GetRecentEventListQueryResult = Apollo.QueryResult<
  GetRecentEventListQuery,
  GetRecentEventListQueryVariables
>;
export function refetchGetRecentEventListQuery(
  variables: GetRecentEventListQueryVariables,
) {
  return { query: GetRecentEventListDocument, variables: variables };
}
